import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { GetClassificationChangesParams, getHintClassificationChanges } from '~/services/ConnectionGoogleService';

export const classificationChangesQueryKeys = {
  all: ['classificationChanges'] as const,
  lists: () => [...classificationChangesQueryKeys.all, 'list'] as const,
  list: (params: GetClassificationChangesParams) => [...classificationChangesQueryKeys.lists(), params] as const,
};

export function useHintClassificationChanges(params: GetClassificationChangesParams) {
  return useQuery({
    queryKey: classificationChangesQueryKeys.list(params),
    queryFn: async ({ signal }) => {
      return getHintClassificationChanges(params, { signal });
    },
    // Unlike the allocated-properties grid, this loads its first page immediately: "what
    // changed recently" is the question the tab exists to answer, so an empty grid on
    // arrival would be a worse default than one query on open.
    placeholderData: keepPreviousData,
  });
}
